export default "<app-navbar></app-navbar>\n<app-components></app-components>\n"